





















import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";
import ComboBoxSelector from "../../../system/selectors/ComboBoxSelector.vue";
import { ReceptionContactDetail } from "../../../../domain/workflow/reception";
import { ReceptionTypeItem } from "../../../../domain/workflow/items";

@Component({
  components: {
    ComboBoxSelector,
  }
})
export default class ReceptionContactDetailEditor extends Mixins(ModelEditableMixin) {
  @Prop()
  contactNameItems: ReceptionTypeItem[];

  @Prop()
  detailIndex: number;

  data(): any {
    return {
      contactNames: [],
    };
  }
  // 選択肢設定が変更された場合を考慮して算出プロパティにしない
  // this.contactNameが"選択肢にない項目"を選択している状態(依頼登録後に設定変更した場合に起こる)のときに
  // 編集でthis.contactNameを"選択肢にある項目"に変更したとき、元の"選択肢にない項目"に戻せなくなるため
  contactNames: string[];

  mounted(): void {
    this.contactNames = this.toContactNames(this.contactNameItems);
  }

  get isRequired(): boolean {
    // null・undefinedだとラジオボタンとしては選択されていないように表示されるが、
    // 登録すると連絡不要(false)になっていて紛らわしいのでtrueかfalseのどちらかになるように判定を入れている
    // 未指定にちゃんと対応するなら不要
    return !!this.editingSource.isRequired;
  }

  set isRequired(value: boolean) {
    this.writeProperty((c: ReceptionContactDetail) => c.isRequired = value);
  }

  get contacts(): string {
    return this.editingSource.contacts;
  }

  set contacts(value: string) {
    this.writeProperty((c: ReceptionContactDetail) => c.contacts = value);
  }

  get contactName(): string {
    return this.editingSource.contactName;
  }

  set contactName(value: string) {
    this.writeProperty((c: ReceptionContactDetail) => c.contactName = value);
  }

  get requiredRadioName(): string {
    return "required" + this.detailIndex;
  }

  toContactNames(items: ReceptionTypeItem[]): string[] {
    // isDisable=false もしくは編集時に選択されている連絡先情報を表示
    return Enumerable.from(items)
      .where(r => !r.isDisable || (this.contactName && r.name === this.contactName))
      .select(r => r.name)
      .toArray();
  }
}
